import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_RESET_EVENT_GROUPS } from './Header';
import axios from 'axios';
import UpcomingEventGroups from './UpcomingEventGroups';
import './Home.css';

const Home = () => {
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [registrationGroupOpen, setRegistrationGroupOpen] = useState(false);

  useEffect(() => {
    if (location.state?.[NAV_RESET_EVENT_GROUPS] == null) return;
    setSelectedEvent(null);
  }, [location.state]);

  const pastEvents = [
    {
      id: 7,
      title: 'Dallas TX Swim Lessons – June & July 2026',
      date: 'Jun. 1, Jun. 16, Jun. 22, Jun. 29, Jul. 13 & Jul. 14, 2026',
      location: 'Fretz Aquatic Center (14778 Hillcrest Rd, Dallas, TX 75254)',
      description:
        'In collaboration with Dallas Parks and Recreation, Swim With a Splash offered private swim lessons led by competitive swimmers from top swimming clubs.'
    },
    {
      id: 6,
      title: 'Southlake Texas Swim Lessons – September 1, 2025',
      date: 'September 1, 2025',
      location: 'Southlake, Texas',
      description: 'Free private swim lessons offered by Lakeside Aquatic Club and North Texas Natadores swimmers.',
      image: '/event-photos/southlake_coach_Picture3.jpg',
      video: '/event-photos/Southlake_2025.mp4',
      teamPhoto: 'southlake_coach_Picture3.jpg',
      teamDescription: 'September 1, 2025\nFrom left to right: Valentina Calderon, Rebecca Yao, Austin Yao, Aiden Ji, Lucas Sun',
      
      /*additionalPhotos: [
        {
          image: '/event-photos/Southlake_2025.mp4',
          date: 'September 1, 2025',
          description: 'Event Video'
        }
      ]*/
    },
    {
      id: 4,
      title: 'Southlake Texas Swim Lessons – August 23 & 24, 2025',
      date: 'August 23 & 24, 2025',
      location: 'Southlake, Texas',
      description: 'Free private swim lessons offered by Lakeside Aquatic Club and North Texas Natadores swimmers.',
      image: '/event-photos/southlake_coach_Picture1.jpg',
      teamPhoto: 'southlake_coach_Picture1.jpg',
      teamDescription: 'August 23, 2025\nFrom left to right: Lucas Sun, Rebecca Yao, Olivia Ye, Austin Yao, (Aiden Ji)',
      additionalPhotos: [
        {
          image: '/event-photos/southlake_coach_Picture2.jpg',
          date: 'August 24, 2025',
          description: 'From left to right: Valentina Calderon, Austin Yao, Aiden Ji, Lucas Sun'
        }
      ]
    },
    {
      id: 5,
      title: 'California Swim Lessons – August 9 & 10, 2025',
      date: 'August 9 & 10, 2025',
      location: 'California',
      description: 'Free private swim lessons offered by Pacific Swim swimmers.',
      image: '/event-photos/CA_Coaches.jpg',
      teamPhoto: 'CA_Coaches.jpg',
      teamDescription: 'From left to right: Katie An，Connor Ho， Yimo Liu，Ryker Liu'
    },
    {
      id: 3,
      title: 'Mason Ohio Swim Lessons – May 24 & 25, 2025',
      date: 'May 24 & 25, 2025',
      location: 'Mason Community Center',
      description: 'Free private swim lessons offered by Mason Manta Rays swimmers.',
      image: '/event-photos/year3mason.jpeg',
      teamPhoto: 'year3mason.jpeg',
      teamDescription: 'From left to right: Sharon Li, Anna Yu, Claire Liu, Caleb Tan, Victor Cao, Andrew Zhang'
    },
    {
      id: 2,
      title: 'Chestnut Hill Mason Ohio Swim Lessons – May 18 & 19, 2024',
      date: 'May 18 & 19, 2024',
      location: 'Chestnut Hill Community Pool',
      description: 'Free private swim lessons offered by Mason Manta Rays swimmers.',
      image: '/event-photos/year2groupphoto.jpg',
      video: '/event-photos/year2.mp4',
      teamPhoto: 'year2groupphoto.jpg',
      teamDescription: 'Front row: Rebecca Yao, George Cao, Andrew Zhang\nSecond row: Sharon Li, Victor Cao, Caleb Tan, Austin Yao'
    },
    {
      id: 1,
      title: 'Chestnut Hill Mason Ohio Swim Lessons – August 14, 15 & 16, 2023',
      date: 'August 14, 15 & 16, 2023',
      location: 'Chestnut Hill Community Pool',
      description: 'Free private swim lessons offered by Mason Manta Rays swimmers.',
      image: '/event-photos/year1groupphoto.jpg',
      video: '/event-photos/year1.mp4',
      teamPhoto: 'year1groupphoto.jpg',
      teamDescription: 'Front row: Victor Cao, Rebecca Yao, and George Cao\nSecond row: Sharon Li, Bryan Zhang, Austin Yao'
    }
  ];

  const handleEventClick = (event) => {
    setSelectedEvent(event);
  };

  const handleBackToHome = () => {
    setSelectedEvent(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const feedbackRes = await axios.get('/api/feedback');
        setFeedback(feedbackRes.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (selectedEvent) {
    return (
      <div className="event-detail">
        <header className="event-header">
          <div className="event-header-content">
            <img src="/logo.png" alt="Swim With a Splash Logo" className="event-logo" />
            <h1>Swim With a Splash</h1>
          </div>
          <nav className="event-nav">
            <button onClick={handleBackToHome}>Back to Home</button>
          </nav>
        </header>
        
        <div className="container">
          <section className="section">
            <h2>{selectedEvent.title}</h2>
            
            <div className="card">
              <h3>Event Details</h3>
              <p><strong>Date:</strong> {selectedEvent.date}</p>
              <p><strong>Location:</strong> {selectedEvent.location}</p>
              <p><strong>Description:</strong> {selectedEvent.description}</p>
              
            </div>
            
            {selectedEvent.image && selectedEvent.teamDescription ? (
            <div className="card">
              <h3>Coach Team</h3>
              <img 
                src={selectedEvent.image} 
                alt={selectedEvent.title} 
                className="event-team-photo"
              />
              <p className="team-description">
                {selectedEvent.teamDescription.split('\n').map((line, index) => (
                  <span key={index}>
                    {line}
                    {index < selectedEvent.teamDescription.split('\n').length - 1 && <br />}
                  </span>
                ))}
              </p>
              
              {selectedEvent.additionalPhotos && selectedEvent.additionalPhotos.map((photo, index) => (
                <div key={index} className="additional-photo">
                  <img 
                    src={photo.image} 
                    alt={`${selectedEvent.title} - ${photo.date}`} 
                    className="event-team-photo"
                  />
                  <p className="team-description">
                    <strong>{photo.date}</strong><br />
                    {photo.description}
                  </p>
                </div>
              ))}
            </div>
            ) : null}
            
            {selectedEvent.video && (
              <div className="card">
                <h3>Event Video</h3>
                <video width="100%" controls className="event-video">
                  <source src={selectedEvent.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            )}
          </section>
        </div>
        
        <button onClick={handleBackToHome} className="back-btn">Back to Home</button>
      </div>
    );
  }

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h2>Building Confident Swimmers & Safer Communities</h2>
          <p>Learn water safety and swimming fundamentals from top competitive swimmers giving back to the community.</p>
          <p className="hero-registration-open">
            <Link to="/events" className="cta-button">
              Registration open
            </Link>
          </p>
        </div>
      </section>

      {/* Two-Column Layout Section */}
      <section className="two-column-section">
        <div className="container">
          <div className="two-column-grid">
            {/* Left Column */}
            <div className="left-column">
              {/* About Section */}
              <div className="content-section">
                <h2>About Us</h2>
                <div className="card">
                  <h3>Mission</h3>
                  <p>At Swim With a Splash, our mission is to give back to the community by teaching children essential swimming skills. Swimming is not only a fun activity but also a critical life skill. We are committed to helping kids feel safe and confident in the water—whether their goal is to simply enjoy time at the pool or to swim faster with stronger technique.</p>
                  
                  <h3>Who We Are</h3>
                  <p>We are a team of passionate competitive swimmers from some of the top clubs in the nation. Since 2023, Swim With a Splash has been bringing high-quality swim lessons and water safety education to local communities. Our coaches are dedicated to sharing their love of swimming while helping each child grow in skill, safety, and confidence.</p>
                  
                  <h3>What We Offer</h3>
                  <p><strong>Learn‑to‑Swim:</strong> This is geared towards children who want to learn how to swim or are in the elementary steps.</p>
                  <p><strong>Stroke Clinic:</strong> If your child is proficient in their strokes, we will help polish your child's skills to bring them to competitive standards.</p>
                </div>
              </div>

              {/* Team Section */}
              <div className="content-section">
                <h2>Team</h2>
                <div className="card">
                  <h3>Meet Our Coaches</h3>
                  <p>Our coaches are competitive swimmers from some of the nation’s top clubs, dedicated to teaching swimming skills and water safety to our community.</p>
                  <Link to="/team" className="learn-more-btn">
                    Meet Our Team
                  </Link>
                </div>
              </div>

              {/* Why Choose Us Section */}
              <div className="content-section">
                <h2>Why Choose Us</h2>
                <div className="card">
                  <ul className="why-choose-list">
                    <li>We prioritize each child's safety at all times.</li>
                    <li>Our private lessons are tailored to individual needs, with coaches assigned based on the information you provide.</li>
                    <li>We understand children and use that knowledge to help them learn and succeed.</li>
                    <li>After every class, we provide personalized feedback to parents.</li>
                  </ul>
                </div>
              </div>

            </div>

            {/* Right Column */}
            <div className="right-column">
              {/* Events Section */}
              <div className="content-section">
                <h2>Events</h2>
                
                <div className="card">
                  <h3>Upcoming Events</h3>
                  <UpcomingEventGroups
                    variant="home"
                    pastEvents={pastEvents}
                    onPastEventClick={handleEventClick}
                    onSelectionChange={(groupId) => setRegistrationGroupOpen(Boolean(groupId))}
                  />
                </div>

                {!registrationGroupOpen ? (
                  <div className="card">
                    <h3>Past Events</h3>
                    {pastEvents.map(event => (
                      <div key={event.id} className="home-event-card">
                        <div className="home-event-header">
                          <h3>{event.title}</h3>
                          <button
                            onClick={() => handleEventClick(event)}
                            className="past-event-learn-more-btn"
                          >
                            Learn More
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>

              {/* Parent Feedback Section */}
              <div className="content-section">
                <h2>Parent Feedback</h2>
                
                {/* Static feedback testimonials */}
                <div className="card">
                  <div className="quote">
                    <div className="quote-mark">"</div>
                    <p>Lucas was so professional, knowledgeable and patient with Leon on both butterfly and freestyle strokes. What he shared were so helpful for Leon to improve. We truly appreciate coach Lucas efforts and time!!!</p>
                  </div>
                </div>

                <div className="card">
                  <div className="quote">
                    <div className="quote-mark">"</div>
                    <p>Our coach Valentina was super patient. She asked what we wanted to achieve before the lesson started and briefed us what she taught. She helped correct Everest arm position and better control breath. We liked it!</p>
                  </div>
                </div>

                <div className="card">
                  <div className="quote">
                    <div className="quote-mark">"</div>
                    <p>Thanks for Rebecca giving my daughter a swimming lesson! She really enjoyed it, and her breaststroke has already gotten better. We appreciate the way you shared your skills and gave back to community. - it means a lot!</p>
                  </div>
                </div>

                <div className="card">
                  <div className="quote">
                    <div className="quote-mark">"</div>
                    <p>Today the most incredible thing just happened to my son! He participated in one of your free lessons for younger kids. In just one class, he finally learned how to do a flip turn—something he had been struggling with for over two years. […] A special thank-you to the coach who worked with him—Austin. He didn’t just explain the flip turn—he threw himself into demonstrating it again and again, with full energy and focus. […] Thank you to everyone who made this program possible. What you're doing is truly meaningful—not just teaching skills, but building confidence and creating moments that kids will carry with them for life.</p>
                  </div>
                </div>

                <div className="card">
                  <div className="quote">
                    <div className="quote-mark">"</div>
                    <p>It is very grateful to have those lovely young people to volunteering teach swimming lessons. It is very meaningful and valuable way to give back to the community. Thanks for their enthusiasm, dedication and patience, my son got impressive advice from them which made a highly positive impact on my son's swimming confidences and his swimming skills. The most hard work is to teaching my 4 years old son, which I believe is kind of mission impossible. Thanks for all their hard working. The whole family do appreciate.</p>
                  </div>
                </div>
                
                <div className="card">
                  <div className="quote">
                    <div className="quote-mark">"</div>
                    <p>Rayaan loved the swim class with Austin! He said he learned lots of good techniques! He wished he could take classes from him regularly this summer at the neighborhood pool.</p>
                  </div>
                </div>
                
                {/* Dynamic feedback from database */}
                {feedback.map((item, index) => (
                  <div key={item.id} className="card">
                    <div className="quote">
                      <div className="quote-mark">"</div>
                      <p>{item.feedback_message}</p>
                    </div>
                  </div>
                ))}
                
                <div className="card">
                  <Link to="/feedback" className="learn-more-btn">
                    Share Your Experience
                  </Link>
                </div>
              </div>

              {/* Contact Section */}
              <div className="content-section">
                <h2>Contact</h2>
                <div className="card">
                  <p><b>Interested in joining our mission</b>—volunteer, partner, or sponsor to help us make waves?<br />
                  <br />
                  Have questions about our programs, want to join the waiting list, or receive updates about future events?<br />
                  <br />
                  Reach us at  <b>swimwithasplash@gmail.com</b></p>
                </div>
              </div>

              
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 